module.exports = __webpack_public_path__ + "img/hugh-and-nora-capron-family.9687de07.jpg";